import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Modal, Button, Form, ListGroup, InputGroup, FormControl, Row, Col, Spinner, Alert, Card, Badge, Table } from 'react-bootstrap';
import axios from 'axios'; // Importar axios
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPlus, faPrint, faCheckCircle, faFileContract, faTabletAlt, faClipboardList } from '@fortawesome/free-solid-svg-icons';
import { useEntidadeContext } from '../EntidadeContext';
import ContratoAssinaturaModal from '../components/consultorio/ContratoAssinaturaModal';
import InputMask from 'react-input-mask';
import { QRCodeCanvas } from 'qrcode.react';

const PaymentModal = ({ show, handleClose, appointment, allServices, allFuncionarios, onPaymentConfirm, pacientePacotesAtivos: initialPacientePacotesAtivos }) => {
 
  const [additionalValue, setAdditionalValue] = useState(0);
  const [isContractSigned, setIsContractSigned] = useState(false);
  const [showContractModal, setShowContractModal] = useState(false);

  // --- NOVOS ESTADOS PARA ANAMNESE ---
  const [isAnamneseComplete, setIsAnamneseComplete] = useState(false);
  const [anamneseCode, setAnamneseCode] = useState(null);
  const [showAnamneseCodeModal, setShowAnamneseCodeModal] = useState(false);
  const [isGeneratingAnamnese, setIsGeneratingAnamnese] = useState(false);

  const [contractCode, setContractCode] = useState(null);
  const [additionalValueDescription, setAdditionalValueDescription] = useState('');
  const [paymentSubtotal, setPaymentSubtotal] = useState(0);
  const [paymentTotal, setPaymentTotal] = useState(0);
  const [appointmentServices, setAppointmentServices] = useState([]);
  const { currentEntidade } = useEntidadeContext();

  // Novos estados para controle financeiro
  const [paymentMethod, setPaymentMethod] = useState('dinheiro'); // dinheiro, credito, debito, pix
  const [cardFeePercentage, setCardFeePercentage] = useState(0); // Percentual da taxa da maquininha
  const [discountPercentage, setDiscountPercentage] = useState(0); // Percentual de desconto (max 5%)

  // --- NOVOS ESTADOS PARA MÚLTIPLOS PAGAMENTOS ---
  const [payments, setPayments] = useState([]); // Lista de pagamentos adicionados
  const [currentPaymentAmount, setCurrentPaymentAmount] = useState(''); // Valor do pagamento sendo adicionado
  const [totalDebt, setTotalDebt] = useState(0); // Valor total da dívida (serviços + adicionais - descontos)

  // Estados para controle de pacotes de serviços
  const [selectedPackageId, setSelectedPackageId] = useState(null);

  // Novos estados para a Fase 2: Cobertura de Convênio
  const [isLoadingCoverage, setIsLoadingCoverage] = useState(false);
  const [coverageDetails, setCoverageDetails] = useState(null); // Para armazenar os detalhes da cobertura

  // Estados para feedback da API
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [paymentApiMessage, setPaymentApiMessage] = useState(null); // { type: 'success'/'danger', text: 'mensagem' }

  // --- NOVOS ESTADOS PARA AUTORIZAÇÃO DE DESCONTO ---
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authPassword, setAuthPassword] = useState('');
  const [isAuthorizing, setIsAuthorizing] = useState(false);
  const [authError, setAuthError] = useState(null);
  const [isDiscountAuthorized, setIsDiscountAuthorized] = useState(false);

  // --- NOVOS ESTADOS PARA CUPOM ---
  const [couponCode, setCouponCode] = useState('');
  const [appliedCoupon, setAppliedCoupon] = useState(null); // { id, codigo, valor_desconto, tipo_desconto }
  const [isValidatingCoupon, setIsValidatingCoupon] = useState(false);

  // --- NOVOS ESTADOS PARA DETALHAR VALORES JÁ PAGOS ---
  const [totalServicosJaPagos, setTotalServicosJaPagos] = useState(0);
  const [totalAdicionaisJaPagos, setTotalAdicionaisJaPagos] = useState(0);
  const [totalDescontoJaConcedido, setTotalDescontoJaConcedido] = useState(0);

  // --- NOVO ESTADO PARA CONTROLE DE CARREGAMENTO INICIAL ---
  const [isLoadingData, setIsLoadingData] = useState(true);

  // --- NOVO ESTADO PARA ARMAZENAR DADOS DO PAGAMENTO REALIZADO (PARA RECIBO) ---
  const [lastPaymentData, setLastPaymentData] = useState(null);

  // --- NOVO ESTADO PARA CPF NO RECIBO ---
  const [receiptCpf, setReceiptCpf] = useState('');

  // --- NOVO ESTADO ---
  // Armazena os IDs dos serviços que já foram pagos em transações anteriores.
  // --- NOVO ESTADO PARA COMISSÃO ORIGINÁRIA ---
  const [originCommission, setOriginCommission] = useState({ enabled: false, funcionario_id: '' });

  const MAX_DISCOUNT_PERCENTAGE = 10;

  // --- NOVOS ESTADOS PARA COMPLEMENTAR DADOS DO PACIENTE ---
  const [showPatientDataModal, setShowPatientDataModal] = useState(false);
  const [isFetchingPatientData, setIsFetchingPatientData] = useState(false);
  const [isUpdatingPatient, setIsUpdatingPatient] = useState(false);
  const [patientForm, setPatientForm] = useState({
    nome: '', cpf: '', estado_civil: '', profissao: '', endereco: '', dddcelular: '', celular: '', email: ''
  });

  // Validação em tempo real para o formulário de complemento de dados
  const isPatientFormInvalid = useMemo(() => {
    return !patientForm.nome.trim() ||
           !patientForm.cpf.trim() ||
           !patientForm.estado_civil ||
           patientForm.estado_civil === 'Nao informado' ||
           !patientForm.profissao.trim() ||
           !patientForm.endereco.trim() ||
           !patientForm.dddcelular.trim() ||
           !patientForm.celular.trim() ||
           !patientForm.email.trim();
  }, [patientForm]);

  const [comissionedServices, setComissionedServices] = useState({}); // {[serviceId]: { enabled: true, funcionario_id: '123' }}
  const [initialServiceIds, setInitialServiceIds] = useState(new Set());

  // Verifica se existe algum funcionário que pode receber comissão.
  // O useMemo garante que este cálculo só seja refeito se a lista de funcionários mudar.
  const hasCommissionableEmployees = useMemo(() => {
    if (!allFuncionarios || allFuncionarios.length === 0) {
        return false;
    }
    return allFuncionarios.some(f => f.comissionavel);
  }, [allFuncionarios]);

  // NOVO: Verifica se existe algum funcionário que pode receber comissão originária.
  const employeesForOriginCommission = useMemo(() => {
    if (!allFuncionarios || allFuncionarios.length === 0) {
        return [];
    }
    // Assumindo que o backend enviará uma nova propriedade `comissionavel_origem` no objeto do funcionário.
    return allFuncionarios.filter(f => f.comissionavel_origem);
  }, [allFuncionarios]);


  // Regra de Negócio: A comissão só é válida se todos os serviços originais forem mantidos.
  const areAllInitialServicesSelected = useMemo(() => {
    if (initialServiceIds.size === 0) {
        return true; // Se não havia serviço inicial, a regra não se aplica.
    }
    // Verifica se CADA serviço inicial ainda está na lista de serviços selecionados.
    return [...initialServiceIds].every(id => 
        appointmentServices.some(s => s.id === id));
  }, [initialServiceIds, appointmentServices]);

  // NOVO: Memo para identificar serviços que já foram pagos e não podem ser desmarcados.
  const paidServiceIds = useMemo(() => {
    if (!appointment?.pagamento) return new Set();
    
    return new Set(appointment.pagamento
      .filter(p => p.status_pagamento === 'Confirmado')
      .flatMap(p => p.servicos.map(s => s.id)));
  }, [appointment]);

  const handleCommissionChange = (serviceId, isChecked) => {
    setComissionedServices(prev => {
        const newState = { ...prev };
        if (isChecked) {
            // Ao marcar, pré-seleciona o médico do agendamento, se houver.
            newState[serviceId] = { enabled: true, funcionario_id: appointment?.medico_id || '' };
        } else {
            delete newState[serviceId];
        }
        return newState;
    });
  };

  // NOVO: Handler para alterar o valor de um serviço específico
  const handleServiceValueChange = (serviceId, newValue) => {
    
    setAppointmentServices(prev =>
      prev.map(s =>
        s.id === serviceId ? { ...s, valor_pago: newValue } : s
      )
    );
  };

  const handleServiceChange = (service) => {
    // Impede que um serviço já pago seja desmarcado.
    if (paidServiceIds.has(service.id)) {
      return;
    }

    const isCurrentlySelected = appointmentServices.some(s => s.id === service.id);

    if (isCurrentlySelected) {
      // Desmarcar
      setAppointmentServices(prev => prev.filter(s => s.id !== service.id));
      setComissionedServices(prev => {
        const newState = { ...prev };
        delete newState[service.id];
        return newState;
      });
    } else {
      // Marcar: Adiciona o serviço com o valor original como valor a ser pago
      setAppointmentServices(prev => [...prev, { ...service, valor_pago: parseFloat(service.valor || 0), quantidade: 1 }]);
    }
  };

  // Memo para ordenar a lista de serviços: selecionados primeiro, depois por ordem alfabética.
  const sortedServices = useMemo(() => {
    if (!allServices) return [];
    // Cria uma cópia para não modificar a prop original
    return [...allServices].sort((a, b) => {
      const isASelected = appointmentServices.some(s => s.id === a.id);
      const isBSelected = appointmentServices.some(s => s.id === b.id);

      if (isASelected && !isBSelected) {
        return -1; // 'a' vem primeiro
      }
      if (!isASelected && isBSelected) {
        return 1; // 'b' vem primeiro
      }
      // Se ambos estão selecionados ou não, ordena por nome
      return a.nome.localeCompare(b.nome);
    });
  }, [allServices, appointmentServices]);

  // Ref para controlar a inicialização e evitar chamadas duplicadas à API
  const initializedAppointmentId = useRef(null);

  useEffect(() => {
    if (!show) {
      initializedAppointmentId.current = null;
      setIsLoadingData(true);
      return;
    }

    const initializeModal = async () => {
      if (!appointment) return;

      if (initializedAppointmentId.current === appointment.id) return;
      initializedAppointmentId.current = appointment.id;

      setIsLoadingData(true);

      // --- INÍCIO DA NOVA LÓGICA ---
      // Em vez de buscar o agendamento, buscamos diretamente os detalhes da consulta pelo novo endpoint.
      let consultaDetalhada = null;
      if (appointment.id) {
        try {
          const response = await axios.get(`/api/consultas/agendamento/${appointment.id}`);
          consultaDetalhada = response.data.consulta;
        } catch (error) {
          // Se der erro 404 (consulta não encontrada), não é um erro fatal.
          // Apenas significa que o atendimento ainda não foi iniciado.
          console.log("Nenhuma consulta iniciada para este agendamento. Usando serviços padrão.");
          consultaDetalhada = null;
        }
      }
      // --- FIM DA NOVA LÓGICA ---

             let initialServices = [];      
      // --- INÍCIO DA CORREÇÃO ---
      // Agora, a verificação é feita em 'consultaDetalhada.servicos' (o array)
      // em vez de 'consultaDetalhada.procedimentos' (a string JSON).
      if (consultaDetalhada && consultaDetalhada.servicos && consultaDetalhada.servicos.length > 0) {
         try {
           // --- INÍCIO DA CORREÇÃO ---
           // 1. Parseia o JSON de procedimentos para obter os dados de quantidade e valor unitário.
           const procedimentosInfo = JSON.parse(consultaDetalhada.procedimentos || '[]');

           // 2. Mapeia o array 'servicos' que vem da API, que já contém a flag 'origin'.
           initialServices = consultaDetalhada.servicos.map(servicoBase => {
               // 3. Encontra o procedimento correspondente no JSON para obter os detalhes de valor.
               const procedimentoDetalhado = procedimentosInfo.find(p => p.nome === servicoBase.nome);

               // 4. Calcula o valor total do item (valor unitário * quantidade).
               const isPacote = servicoBase.has_active_package;
               const valorTotalItem = isPacote 
                   ? 0 
                   : (procedimentoDetalhado
                       ? parseFloat(procedimentoDetalhado.valor_unitario || 0) * (parseInt(procedimentoDetalhado.quantidade, 10) || 1)
                       : parseFloat(servicoBase.valor || 0)); // Fallback para o valor padrão do serviço.

               return { 
                 ...servicoBase,
                 valor_pago: valorTotalItem,
                 quantidade: procedimentoDetalhado?.quantidade || 1, // Armazena a quantidade para exibição
                 isPacote: isPacote,
                 active_package_id: servicoBase.active_package_id // Armazena o ID do pacote para uso no pagamento
               };
             });
           // --- FIM DA CORREÇÃO ---
         } catch (e) {
           console.error("Erro ao processar serviços da consulta:", e);
           initialServices = (appointment.servicos || []).map(service => ({ ...service, valor_pago: parseFloat(service.valor || 0) }));
         }
      } else {
        // Fallback: se não houver serviços na consulta, usa os do agendamento.
        initialServices = (appointment.servicos || []).map(service => ({ ...service, valor_pago: parseFloat(service.valor || 0), quantidade: 1 }));
      }

      setAppointmentServices(initialServices);

      setInitialServiceIds(new Set(initialServices.map(s => s.id)));
      
      // Reseta outros campos
      setAdditionalValue(0);
      setAdditionalValueDescription('');
      setPaymentMethod('dinheiro');
      setCardFeePercentage(0);
      setDiscountPercentage(0);
      setPaymentApiMessage(null);
      setComissionedServices({}); // Reseta as comissões
      setIsDiscountAuthorized(false); // Reseta a autorização de desconto
      setCoverageDetails(null);
      setSelectedPackageId(null); // Reseta o pacote selecionado
      setTotalServicosJaPagos(0); // Reseta totais
      setTotalAdicionaisJaPagos(0); // Reseta totais
      setOriginCommission({ enabled: false, funcionario_id: '' }); // Reseta a comissão originária
      
      // NOVO: Verifica se o agendamento ou a consulta detalhada já possuem contrato assinado
      setIsContractSigned(!!appointment.has_signed_contract || !!consultaDetalhada?.has_signed_contract);

      // Inicializa status da anamnese (posteriormente este dado virá da sua API de agendamento)
      setIsAnamneseComplete(false);

      // Reseta cupons
      setCouponCode('');
      setAppliedCoupon(null);
      
      // Inicializa o CPF do recibo com o do paciente, se houver
      setReceiptCpf(appointment.paciente?.cpf || '');
      
      // Reseta lista de pagamentos
      setPayments([]);
      setCurrentPaymentAmount('');
      setTotalDebt(0);
      setIsLoadingData(false);
      setLastPaymentData(null); // Reseta os dados do último pagamento ao abrir/fechar
    }
  initializeModal();
  }, [show, appointment, allServices]); // Adicionado allServices como dependência

  // --- NOVO: POLLING PARA VERIFICAR STATUS DA ANAMNESE ---
  useEffect(() => {
    let interval;
    if (showAnamneseCodeModal && anamneseCode) {
      interval = setInterval(async () => {
        try {
          const response = await axios.get(`/api/anamnese/status/${anamneseCode}`);
          if (response.data.status === 'preenchido') {
            setIsAnamneseComplete(true);
            setShowAnamneseCodeModal(false);
            clearInterval(interval);
          }
        } catch (error) {
          console.error("Erro ao verificar status da anamnese:", error);
        }
      }, 3000); // Verifica a cada 3 segundos
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [showAnamneseCodeModal, anamneseCode]);

  const handleCommissionEmployeeChange = (serviceId, funcionarioId) => {
    setComissionedServices(prev => ({
        ...prev,
        [serviceId]: { ...prev[serviceId], funcionario_id: funcionarioId }
    }));
  };

  // --- NOVA FUNÇÃO PARA APLICAR CUPOM ---
  const handleApplyCoupon = async () => {
    if (!couponCode) return;
    setIsValidatingCoupon(true);
    setPaymentApiMessage(null);
    try {
      const response = await axios.post('/api/cupons/validate', {
        codigo: couponCode,
        subtotal: paymentSubtotal,
        entidade_id: appointment.entidade_id
      });
      setAppliedCoupon(response.data);
      setDiscountPercentage(0); // Reseta o desconto manual ao aplicar um cupom
      setPaymentApiMessage({ type: 'success', text: `Cupom ${couponCode} aplicado com sucesso!` });
    } catch (error) {
      const msg = error.response?.data?.message || 'Erro ao validar cupom.';
      setPaymentApiMessage({ type: 'danger', text: msg });
      setAppliedCoupon(null);
    } finally {
      setIsValidatingCoupon(false);
    }
  };

  const handleRemoveCoupon = () => {
    setAppliedCoupon(null);
    setCouponCode('');
  };

  // Efeito para recalcular o subtotal sempre que os serviços selecionados mudam.
  useEffect(() => {
    // Calcula o subtotal somando os valores editáveis (valor_pago) dos serviços que NÃO são de pacote.
    const subtotal = appointmentServices.reduce((sum, service) => {
      const isFromPackage = service.isPacote;
      if (!isFromPackage) {
        return sum + parseFloat(service.valor_pago || 0);
      }
      return sum;
    }, 0);
    setPaymentSubtotal(subtotal);
  }, [appointmentServices]);

  // Novo useEffect para buscar os detalhes da cobertura do convênio
  useEffect(() => {
    let isMounted = true; // Flag para evitar race conditions e updates em componente desmontado

    const fetchCoverage = async () => {
      // Condição para buscar: precisa ser paciente de convênio e ter serviços selecionados.
      const shouldFetch = show && appointment?.paciente?.tp_convenio === 'Convenio' && appointmentServices.length > 0;
      if (shouldFetch) {
        setIsLoadingCoverage(true);
        // Filtra os IDs dos serviços para buscar cobertura, excluindo os que já são de pacotes.
        const serviceIdsForCoverage = appointmentServices
          .filter(s => !s.isPacote)
          .map(s => s.id);

        // Se não houver serviços elegíveis para cobertura, não faz a chamada.
        if (serviceIdsForCoverage.length === 0) {
          setIsLoadingCoverage(false);
          setCoverageDetails(null);
          return;
        }

        try {
          const response = await axios.get(`/api/agendamentos/${appointment.id}/cobertura`, {
            params: { servicos: serviceIdsForCoverage }
          });
          if (isMounted) {
            // A API pode retornar uma resposta de sucesso com dados vazios se não houver cobertura.
            // Verificamos se a resposta tem dados significativos antes de setar.
            if (response.data && Object.keys(response.data).length > 0 && response.data.valor_total_coberto_convenio > 0) {
              setCoverageDetails(response.data);
            } else {
              setCoverageDetails(null);
            }
          }
        } catch (error) {
          if (isMounted) {
            console.error("Erro ao verificar cobertura:", error);
            setCoverageDetails(null); // Limpa em caso de erro (ex: 404)
          }
        } finally {
          if (isMounted) {
            setIsLoadingCoverage(false);
          }
        }
      } else {
        // Se não deve buscar, garante que os detalhes da cobertura sejam nulos.
        setCoverageDetails(null);
      }
    };

    fetchCoverage();

    return () => {
      isMounted = false; // Cleanup para evitar setar estado em componente desmontado ou em chamadas antigas
    };
  }, [appointment, show, appointmentServices]);

  // NOVO: Memo para calcular o valor pago por serviço (considerando apenas pagamentos confirmados)
  const paidAmountPerService = useMemo(() => {
    const paidMap = {};
    if (appointment && appointment.pagamento) {
      appointment.pagamento.forEach(p => {
         if (p.status_pagamento === 'Confirmado' && p.servicos) {
             p.servicos.forEach(s => {
                 const val = parseFloat(s.pivot.valor_servico_no_momento_pagamento || 0);
                 paidMap[s.id] = (paidMap[s.id] || 0) + val;
             });
         }
      });
    }
    return paidMap;
  }, [appointment]);

  useEffect(() => {
    // Calcula os valores já pagos (serviços e adicionais) e armazena nos estados.
    const pagamentosAnteriores = appointment?.pagamento || [];
    const servicosPagos = appointmentServices.reduce((acc, service) => {
        const valorAtual = service.isPacote ? 0 : parseFloat(service.valor_pago || 0);
        const valorPagoHistorico = paidAmountPerService[service.id] || 0;
        // Consideramos como "pago" apenas até o limite do valor atual do serviço.
        return acc + Math.min(valorAtual, valorPagoHistorico);
    }, 0);
    const adicionaisPagos = pagamentosAnteriores.reduce((acc, p) => {
      return acc + parseFloat(p.valor_adicional || 0);
    }, 0);

    setTotalServicosJaPagos(servicosPagos);
    setTotalAdicionaisJaPagos(adicionaisPagos);

    // Calcula o desconto total já concedido em pagamentos anteriores
    const descontoConcedido = pagamentosAnteriores.reduce((acc, p) => {
        const subtotalPagamentoAnterior = parseFloat(p.valor_total_servicos || 0) + parseFloat(p.valor_adicional || 0);
        const descontoPercentual = parseFloat(p.percentual_desconto || 0);
        return acc + (subtotalPagamentoAnterior * (descontoPercentual / 100));
    }, 0);
    setTotalDescontoJaConcedido(descontoConcedido);
    
    // O valor base que o paciente deve pagar.
    // Se houver detalhes de cobertura, é a coparticipação. Senão, é o subtotal dos serviços.
    const patientPortion = paymentSubtotal - (coverageDetails
      ? parseFloat(coverageDetails.valor_total_coberto_convenio || 0)
      : 0);

    // O subtotal agora é a porção do paciente (serviços atuais) MENOS o que já foi pago por serviços,
    // SOMADO ao novo valor adicional que está sendo inserido neste momento.
    const subtotalWithAdditions = (patientPortion - servicosPagos) + parseFloat(additionalValue || 0);

    // Garante que o desconto não seja negativo e remove zeros à esquerda
    // O desconto agora é aplicável a todas as formas de pagamento.
    let validDiscountPercentage = Math.max(0, parseFloat(String(discountPercentage).replace(/^0+/, '')) || 0);

    if (validDiscountPercentage > 5 && !isDiscountAuthorized) {
      validDiscountPercentage = 5; // Limita a 5% se não estiver autorizado
    }

    let discountAmount = 0;
    if (validDiscountPercentage > 0) {
        // Aplica o desconto máximo se o valor digitado exceder
        const appliedDiscountPerc = Math.min(validDiscountPercentage, MAX_DISCOUNT_PERCENTAGE);
        discountAmount = (appliedDiscountPerc / 100) * subtotalWithAdditions;
    }

    const amountAfterDiscount = subtotalWithAdditions - discountAmount;
    // setTotalDebt(amountAfterDiscount);

    // Aplica o desconto do cupom sobre o valor após o desconto manual
    const couponDiscount = appliedCoupon ? parseFloat(appliedCoupon.valor_desconto) : 0;
    const finalDebt = Math.max(0, amountAfterDiscount - couponDiscount);

    setTotalDebt(finalDebt);

    // Se a lista de pagamentos estiver vazia, sugere o valor total restante
    if (payments.length === 0) {
        // setCurrentPaymentAmount(amountAfterDiscount.toFixed(2));
        setCurrentPaymentAmount(finalDebt.toFixed(2));
    }

  }, [paymentSubtotal, additionalValue, discountPercentage, coverageDetails, appointment, appointmentServices, paidAmountPerService, totalServicosJaPagos, totalAdicionaisJaPagos, totalDescontoJaConcedido, payments.length, isDiscountAuthorized, appliedCoupon]);

  // Efeito para atualizar o total pago (soma dos pagamentos)
  useEffect(() => {
      const total = payments.reduce((acc, p) => acc + p.total_pago, 0);
      setPaymentTotal(total);
  }, [payments]);

  // Função para adicionar um pagamento à lista
  const handleAddPayment = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const amount = parseFloat(currentPaymentAmount);
    if (!amount || amount <= 0) {
        return;
    }

    // Validação: Impede adicionar valor maior que a dívida restante
    const currentPaidBase = payments.reduce((acc, p) => acc + p.valor, 0);
    const remainingDebt = Math.max(0, totalDebt - currentPaidBase);

    if (amount > remainingDebt + 0.001) { // +0.001 para tolerância de arredondamento
        setPaymentApiMessage({ type: 'warning', text: `O valor (R$ ${amount.toFixed(2)}) excede o restante a pagar (R$ ${remainingDebt.toFixed(2)}).` });
        return;
    }
    setPaymentApiMessage(null);
    
    let feeAmount = 0;
    if ((paymentMethod === 'credito' || paymentMethod === 'debito') && cardFeePercentage > 0) {
        feeAmount = amount * (parseFloat(cardFeePercentage) / 100);
    }
    
    const newPayment = {
        id: Date.now(), // ID temporário para a lista
        forma_pagamento: paymentMethod,
        valor: amount, // Valor base que abate a dívida
        taxa_maquininha: parseFloat(cardFeePercentage || 0),
        valor_taxa: feeAmount,
        total_pago: amount + feeAmount // Valor total com taxa (se houver)
    };
    
    const updatedPayments = [...payments, newPayment];
    setPayments(updatedPayments);
    
    // Reseta inputs e sugere o restante
    setPaymentMethod('dinheiro');
    setCardFeePercentage(0);
    
    const updatedPaidBase = updatedPayments.reduce((acc, p) => acc + p.valor, 0);
    const remaining = Math.max(0, totalDebt - updatedPaidBase);
    setCurrentPaymentAmount(remaining.toFixed(2));
  };

  // Função para remover um pagamento da lista
  const handleRemovePayment = (id) => {
      const updatedPayments = payments.filter(p => p.id !== id);
      setPayments(updatedPayments);
      
      // Recalcula sugestão de valor restante
      const currentPaidBase = updatedPayments.reduce((acc, p) => acc + p.valor, 0);
      const remaining = Math.max(0, totalDebt - currentPaidBase);
      setCurrentPaymentAmount(remaining.toFixed(2));
  };

  // Função auxiliar para disparar a geração após validação
  const executeContractGeneration = async () => {
    try {
      const response = await axios.post('/api/contratos/gerar-codigo', {
        agendamento_id: appointment.id,
        servicos: appointmentServices.map(s => ({ nome: s.nome, valor: parseFloat(s.valor || 0), valor_pago: s.valor_pago, quantidade: s.quantidade || 1 })),
        discount_percentage: discountPercentage,
        applied_coupon: appliedCoupon,
      });
      setContractCode(response.data.codigo);
      setShowContractModal(true);
    } catch (error) {
      setPaymentApiMessage({ type: 'danger', text: 'Erro ao gerar código do contrato.' });
    }
  };

  // Função para iniciar o processo de contrato
  const handleGenerateContract = async () => {
    if (!appointment.paciente?.id) return;

    setIsFetchingPatientData(true);
    let p = appointment.paciente;

    try {
      // Busca os dados completos do paciente para garantir que o contrato tenha todas as informações
      const response = await axios.get(`/api/pacientes/${appointment.paciente.id}`);
      p = response.data.paciente || response.data;
      
      // Atualiza o objeto no agendamento para refletir os dados completos nas etapas seguintes
      appointment.paciente = { ...appointment.paciente, ...p };
    } catch (error) {
      console.error("Erro ao buscar dados completos do paciente:", error);
      setPaymentApiMessage({ type: 'danger', text: 'Não foi possível carregar os dados cadastrais do paciente para validação.' });
      setIsFetchingPatientData(false);
      return;
    } finally {
      setIsFetchingPatientData(false);
    }
    
    // Verificação de dados básicos exigidos
    const isDataIncomplete = !p.nome || !p.cpf || !p.endereco || !p.dddcelular || !p.celular || !p.email || 
                             !p.profissao || !p.estado_civil || p.estado_civil === 'Nao informado';

    if (isDataIncomplete) {
      setPatientForm({
        nome: p.nome || '',
        cpf: p.cpf || '',
        estado_civil: p.estado_civil || 'Nao informado',
        profissao: p.profissao || '',
        endereco: p.endereco || '',
        dddcelular: p.dddcelular || '',
        celular: p.celular || '',
        email: p.email || '',
      });
      setShowPatientDataModal(true);
      return;
    }

    await executeContractGeneration();
  };

  // Função para iniciar o processo de anamnese (Simulação Frontend)
  const handleGenerateAnamneseCode = async () => {
    setIsGeneratingAnamnese(true);
    try {
      const response = await axios.post('/api/anamnese/gerar-codigo', { 
        agendamento_id: appointment.id 
      });
      setAnamneseCode(response.data.codigo);
      setShowAnamneseCodeModal(true);
    } catch (error) {
      setPaymentApiMessage({ type: 'danger', text: 'Erro ao gerar código da anamnese.' });
    } finally {
      setIsGeneratingAnamnese(false);
    }
  };

  // Salva os dados do paciente antes de gerar o contrato
  const handleUpdatePatientAndGenerate = async () => {
    if (isPatientFormInvalid) {
      setPaymentApiMessage({ type: 'warning', text: 'Por favor, preencha todos os campos obrigatórios.' });
      return;
    }

    setIsUpdatingPatient(true);
    try {
      await axios.put(`/api/pacientes/${appointment.paciente.id}`, patientForm);
      
      // Atualiza o objeto local para refletir as mudanças sem precisar de re-fetch
      appointment.paciente = { ...appointment.paciente, ...patientForm };
      
      setShowPatientDataModal(false);
      await executeContractGeneration();
    } catch (error) {
      const errorMsg = error.response?.data?.message || 'Erro ao atualizar dados do paciente.';
      setPaymentApiMessage({ type: 'danger', text: errorMsg });
    } finally {
      setIsUpdatingPatient(false);
    }
  };

const handleConfirm = async () => {
    if (!isContractSigned && currentEntidade.exigir_contrato_no_pagamento) {
        setPaymentApiMessage({ type: 'warning', text: 'O contrato deve ser assinado antes do pagamento.' });
        return;
    }

    if (payments.length === 0) {
        setPaymentApiMessage({ type: 'warning', text: 'Adicione pelo menos um pagamento.' });
        return;
    }

    // Validação: Impede confirmar se o valor pago for menor que a dívida
    const totalPaidBase = payments.reduce((acc, p) => acc + p.valor, 0);
    if (totalPaidBase < totalDebt - 0.01) {
        setPaymentApiMessage({ type: 'warning', text: `O valor total pago (R$ ${totalPaidBase.toFixed(2)}) é menor que o total a pagar (R$ ${totalDebt.toFixed(2)}).` });
        return;
    }

    setIsProcessingPayment(true);
    setPaymentApiMessage(null);

    // --- INÍCIO DA CORREÇÃO ---
    // Calcula o valor total dos serviços que já foram pagos em transações anteriores.
    const valorServicosJaPagos = (appointment?.pagamento || []).reduce((acc, p) => acc + parseFloat(p.valor_total_servicos || 0), 0);

    // O subtotal para ESTE pagamento específico é o subtotal atual menos o que já foi pago.
    // Isso garante que estamos registrando apenas o valor dos novos serviços.
    const subtotalParaEstePagamento = Math.max(0, paymentSubtotal - valorServicosJaPagos);
    // --- FIM DA CORREÇÃO ---

    // Calcula o fator de desconto percentual (se houver)
    const discountFactor = 1 - (parseFloat(discountPercentage || 0) / 100);

    // Calcula o valor total dos serviços que serão pagos nesta transação, após o desconto percentual
    // Este é o valor base para distribuir o desconto do cupom
    const totalServicesValueBeforeCoupon = appointmentServices.reduce((sum, service) => {
        // Apenas considera serviços que não são pacotes e estão selecionados para pagamento
        // E aplica o desconto percentual ao seu valor individual
        if (!service.isPacote) { // Assumindo que a comissão não é sobre pacotes
            return sum + (parseFloat(service.valor_pago || 0) * discountFactor);
        }
        return sum;
    }, 0);

    let couponDiscountFactor = 1;
    if (appliedCoupon && totalServicesValueBeforeCoupon > 0) {
        // Calcula o fator de desconto do cupom, proporcionalmente ao valor dos serviços após o desconto percentual
        const couponValue = parseFloat(appliedCoupon.valor_desconto);
        couponDiscountFactor = 1 - (couponValue / totalServicesValueBeforeCoupon);
        // Garante que o fator não seja negativo (se o cupom for maior que o total dos serviços)
        couponDiscountFactor = Math.max(0, couponDiscountFactor);
    }

    const servicosPagosParaApi = appointmentServices.map(service => {
      // A comissão só é válida se o serviço foi adicionado na consulta (tem consulta_id no pivot)
      const isCommissionable = !!service.pivot?.consulta_id;
      const isEnabled = isCommissionable && !!comissionedServices[service.id]?.enabled;

      // Aplica o desconto diretamente no valor a ser pago pelo serviço.
      let finalValorPago = parseFloat(service.valor_pago || 0) * discountFactor;
      
      // Aplica o desconto do cupom proporcionalmente, mas apenas para serviços que não são pacotes
      if (!service.isPacote) { // Aplica o desconto do cupom apenas aos serviços que contribuem para totalServicesValueBeforeCoupon
          finalValorPago *= couponDiscountFactor;
      }

      let finalCommissionValue = 0;

      if (isEnabled) {
        const percentualComissao = parseFloat(service.percentual_comissao || 0);
        // A comissão agora é calculada sobre o valor final já com desconto.
        finalCommissionValue = (finalValorPago * percentualComissao) / 100;
      }

      return {
        id: service.id,
        valor: finalValorPago, // Envia o valor do serviço JÁ com o desconto aplicado.
        comissionado: isCommissionable && !!comissionedServices[service.id]?.enabled,
        valor_comissao: finalCommissionValue, // NOVO: Envia o valor final da comissão
        funcionario_id: isCommissionable ? (comissionedServices[service.id]?.funcionario_id || null) : null
      };
    });

    // Identifica os IDs dos pacotes que estão sendo utilizados
    const pacotesUtilizadosIds = appointmentServices
      .filter(service => service.active_package_id)
      .map(service => service.active_package_id);

        // Calcular valores para armazenamento no banco de dados (Bruto e Desconto Total)
    const subtotalBrutoServicos = appointmentServices.reduce((sum, service) => {
      return !service.isPacote ? sum + parseFloat(service.valor_pago || 0) : sum;
    }, 0);

    const valorDescontoManual = subtotalBrutoServicos * (parseFloat(discountPercentage || 0) / 100);
    const valorDescontoCupom = appliedCoupon ? parseFloat(appliedCoupon.valor_desconto) : 0;
    const valorTotalDesconto = valorDescontoManual + valorDescontoCupom;

    // --- INÍCIO DA NOVA LÓGICA DE COMISSÃO ORIGINÁRIA ---
    let originCommissionPayload = null;
    if (originCommission.enabled && originCommission.funcionario_id) {
      // Calcula o valor total dos serviços originais do agendamento
      // --- INÍCIO DA CORREÇÃO ---
      // Filtra apenas os serviços que são originais do agendamento e estão selecionados para pagamento.
      const valorTotalServicosOriginais = appointmentServices
        .filter(service => initialServiceIds.has(service.id)) // Filtra apenas os serviços que estavam no agendamento inicial
        .reduce((acc, service) => {
          return acc + parseFloat(service.valor_pago || 0);
        }, 0);
      // --- FIM DA CORREÇÃO ---

      // A comissão é de 4% sobre o valor dos serviços originais.
      const valorComissao = valorTotalServicosOriginais * 0.04;

      originCommissionPayload = {
        ...originCommission,
        valor_comissao: valorComissao,
      };
    }
    // Payload para a API, agora com detalhes do convênio (Fase 2)
    const paymentData = {
      agendamento_id: appointment.id,
      entidade_id: appointment.entidade_id, // Certifique-se que 'entidade_id' está no objeto 'appointment'
      
      // Envia a lista de pagamentos. Remove o ID temporário antes de enviar.
      pagamentos: payments.map(({id, ...rest}) => rest),
      
      // Mantém compatibilidade ou define um padrão para campos legados se necessário
      forma_pagamento: payments.length === 1 ? payments[0].forma_pagamento : 'multiplo',
      percentual_taxa_maquininha: payments.length === 1 ? payments[0].taxa_maquininha : 0,

      valor_total_servicos: subtotalBrutoServicos, // Envia o subtotal bruto para a tabela
      valor_desconto: valorTotalDesconto, // Envia o valor absoluto do desconto (manual + cupom)
      

      servicos_pagos: servicosPagosParaApi,
      valor_total_pago: paymentTotal, // Valor final que o paciente efetivamente pagou (soma dos pagamentos)
      valor_adicional: parseFloat(additionalValue || 0),
      descricao_valor_adicional: additionalValueDescription,
      percentual_desconto: parseFloat(discountPercentage || 0),
      // --- NOVOS CAMPOS PARA FASE 2 ---
      eh_convenio: !!coverageDetails, // Envia true se for um atendimento por convênio
      cupom_id: appliedCoupon ? appliedCoupon.id : null, // Envia o ID do cupom se houver
      pacotes_ids: pacotesUtilizadosIds, // Envia um array com os IDs dos pacotes utilizados
      origin_commission: originCommissionPayload, // Envia o payload com o valor calculado
      valor_coparticipacao_paciente: coverageDetails ? parseFloat(coverageDetails.valor_coparticipacao_paciente) : null,
      valor_coberto_convenio: coverageDetails ? parseFloat(coverageDetails.valor_total_coberto_convenio) : null,
    };

    try {
      const response = await axios.post('/api/pagamentos', paymentData);
      if (response.status === 201) {
        setPaymentApiMessage({ type: 'success', text: 'Pagamento registrado com sucesso!' });
        
        // CORREÇÃO: Chama o callback `onPaymentConfirm` passando o objeto `agendamento` completo
        // que é retornado dentro do objeto `pagamento` pela API.
        // O componente pai (`AgendasTab`) usará isso para atualizar o estado.
        onPaymentConfirm(response.data.pagamento.agendamento);
        
        // Armazena os dados do pagamento para exibir a tela de sucesso/recibo
        setLastPaymentData(response.data.pagamento);
        
        // REMOVIDO: setTimeout para fechar o modal. Agora o usuário fecha manualmente ou imprime.
      } else {
        // Tratar outros status de sucesso se necessário
        setPaymentApiMessage({ type: 'warning', text: `Resposta inesperada do servidor: ${response.status}` });
      }
    } catch (error) {
      console.error("Erro ao registrar pagamento:", error.response || error.message);
      const errorMessage = error.response?.data?.error || 'Erro ao registrar pagamento. Tente novamente.';
      setPaymentApiMessage({ type: 'danger', text: errorMessage });
    } finally {
      setIsProcessingPayment(false);
    }
  };

  // --- NOVA FUNÇÃO PARA LIDAR COM A MUDANÇA DE DESCONTO ---
  const handleDiscountChange = (e) => {
    const rawVal = String(e.target.value).replace(/^0+(?=\d)/, '');
    const val = Math.max(0, parseFloat(rawVal) || 0);
    const finalVal = Math.min(val, MAX_DISCOUNT_PERCENTAGE);

    // Se o desconto for maior que 5% e ainda não estiver autorizado, abre o modal de autorização.
    if (finalVal > 5 && !isDiscountAuthorized) {
      setShowAuthModal(true);
    }
    setDiscountPercentage(finalVal);
  };

  // --- NOVA FUNÇÃO PARA SUBMETER A AUTORIZAÇÃO ---
  const handleAuthorizeDiscount = async () => {
    setIsAuthorizing(true);
    setAuthError(null);
    try {
      await axios.post('/api/authorize-action', { password: authPassword, action_type: 'discount' });
      setIsDiscountAuthorized(true); // Marca como autorizado
      setShowAuthModal(false); // Fecha o modal de autorização
      setAuthPassword(''); // Limpa a senha após o sucesso
    } catch (error) {
      setAuthError(error.response?.data?.message || 'Falha na autorização.');
      setAuthPassword(''); // Limpa a senha também em caso de erro, forçando o usuário a digitar novamente.
    } finally {
      setIsAuthorizing(false);
    }
  };

  // NOVO: Handler para validar o valor quando o campo perde o foco (onBlur)
  const handleServiceValueBlur = (serviceId) => {
    const service = appointmentServices.find(s => s.id === serviceId);
    if (!service) return;

    const originalValue = parseFloat(service.valor || 0);
    let currentValue = parseFloat(String(service.valor_pago).replace(/^0+(?=\d)/, '')) || 0;

    // Se o valor atual for menor que o original ou inválido, reverte para o original.
    if (currentValue < originalValue) {
      currentValue = originalValue;
    }

    handleServiceValueChange(serviceId, currentValue.toFixed(2)); // Atualiza o estado com o valor validado e formatado
  };

  // --- NOVA FUNÇÃO PARA IMPRIMIR RECIBO ---
  const handlePrintReceipt = () => {
    const receiptWindow = window.open('', '_blank');
    const date = new Date().toLocaleDateString('pt-BR');
    const time = new Date().toLocaleTimeString('pt-BR');

    // Helper para montar a URL da imagem
    const getStorageUrl = (path) => {
        if (!path) return null;
        let baseUrl = process.env.REACT_APP_API_URL || '';
        baseUrl = baseUrl.replace(/\/api\/?$/, ''); // Remove /api do final se existir
        baseUrl = baseUrl.replace(/\/$/, ''); // Remove barra final
        const cleanPath = path.replace(/^\//, '');
        return `${baseUrl}/storage/${cleanPath}`;
    };

    const logoUrl = currentEntidade?.logo_path ? getStorageUrl(currentEntidade.logo_path) : null;
    const nomeClinica = currentEntidade?.nome || 'CLÍNICA';
    
    const content = `
        <html>
        <head>
            <title>Recibo - ${appointment.paciente?.nome}</title>
            <style>
                body { font-family: 'Courier New', Courier, monospace; padding: 20px; max-width: 400px; margin: 0 auto; }
                .header { text-align: center; margin-bottom: 20px; border-bottom: 1px dashed #000; padding-bottom: 10px; }
                .header img { max-width: 150px; max-height: 80px; margin-bottom: 10px; }
                .info { margin-bottom: 15px; }
                .items { width: 100%; margin-bottom: 15px; }
                .items th { text-align: left; border-bottom: 1px dashed #000; }
                .items td { padding: 5px 0; }
                .totals { border-top: 1px dashed #000; padding-top: 10px; }
                .total-row { display: flex; justify-content: space-between; font-weight: bold; margin-top: 5px; }
                .footer { text-align: center; margin-top: 30px; font-size: 12px; }
                @media print {
                    @page { margin: 0; }
                    body { padding: 10px; }
                }
            </style>
        </head>
        <body>
            <div class="header">
                ${logoUrl ? `<img src="${logoUrl}" alt="${nomeClinica}">` : ''}
                <h3>${nomeClinica}</h3>
                <p>Recibo de Pagamento</p>
            </div>
            <div class="info">
                <p><strong>Data:</strong> ${date} ${time}</p>
                <p><strong>Paciente:</strong> ${appointment.paciente?.nome}</p>
                ${receiptCpf ? `<p><strong>CPF:</strong> ${receiptCpf}</p>` : ''}
            </div>
            <table class="items">
                <thead>
                    <tr>
                        <th>Descrição</th>
                        <th style="text-align: right;">Valor</th>
                    </tr>
                </thead>
                <tbody>
                    ${appointmentServices.map(s => {
                         // Lista os serviços selecionados para pagamento
                         return `<tr>
                            <td>${s.nome} ${s.isPacote ? '(Pacote)' : ''}</td>
                            <td style="text-align: right;">R$ ${parseFloat(s.valor_pago).toFixed(2)}</td>
                         </tr>`;
                    }).join('')}
                </tbody>
            </table>
            <div class="totals">
                ${payments.map(p => `
                    <div style="display: flex; justify-content: space-between; font-size: 14px;">
                        <span>${p.forma_pagamento.toUpperCase()}</span>
                        <span>R$ ${p.valor.toFixed(2)}</span>
                    </div>
                `).join('')}
                <div class="total-row">
                    <span>TOTAL PAGO</span>
                    <span>R$ ${parseFloat(paymentTotal).toFixed(2)}</span>
                </div>
            </div>
            <div class="footer">
                <p>Obrigado pela preferência!</p>
            </div>
        </body>
        </html>
    `;
    
    receiptWindow.document.write(content);
    receiptWindow.document.close();
    receiptWindow.focus();
    setTimeout(() => {
        receiptWindow.print();
        receiptWindow.close();
    }, 500);
  };

  // --- NOVAS FUNÇÕES PARA COMISSÃO ORIGINÁRIA ---
  const handleOriginCommissionChange = (isChecked) => {
    setOriginCommission(prev => ({
      ...prev,
      enabled: isChecked,
      // Limpa o funcionário selecionado se desmarcar
      funcionario_id: isChecked ? prev.funcionario_id : ''
    }));
  };

  const handleOriginCommissionEmployeeChange = (funcionarioId) => {
    setOriginCommission(prev => ({ ...prev, funcionario_id: funcionarioId }));
  };

  if (!appointment) {
    return null;
  }

  // Cálculo do valor restante a ser pago
  const paidBaseTotal = payments.reduce((acc, p) => acc + p.valor, 0);
  const remainingAmount = Math.max(0, totalDebt - paidBaseTotal);

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Pagamento dos serviços agendados</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoadingData ? (
          <div className="d-flex flex-column justify-content-center align-items-center py-5">
            <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Carregando...</span>
            </Spinner>
            <div className="mt-3 text-muted">Carregando detalhes do pagamento...</div>
          </div>
        ) : (
        // Se houver dados de pagamento confirmado, mostra a tela de sucesso/recibo
        lastPaymentData ? (
            <div className="text-center py-4" style={{ animation: 'fadeIn 0.5s' }}>
                <div className="mb-3 text-success">
                    <FontAwesomeIcon icon={faCheckCircle} size="4x" />
                </div>
                <h4 className="text-success">Pagamento Confirmado!</h4>
                <p className="lead">O pagamento de <strong>R$ {parseFloat(paymentTotal).toFixed(2)}</strong> foi registrado com sucesso.</p>

                <div className="mx-auto mb-4" style={{ maxWidth: '300px' }}>
                    <Form.Group controlId="receiptCpf">
                        <Form.Label>CPF na Nota (Opcional):</Form.Label>
                        <FormControl
                            type="text"
                            value={receiptCpf}
                            onChange={(e) => setReceiptCpf(e.target.value)}
                            placeholder="000.000.000-00"
                        />
                    </Form.Group>
                </div>

                <div className="d-grid gap-2 col-8 mx-auto mt-5">
                    <Button variant="outline-primary" size="lg" onClick={handlePrintReceipt}>
                        <FontAwesomeIcon icon={faPrint} className="me-2" /> Imprimir Recibo
                    </Button>
                    <Button variant="secondary" onClick={handleClose}>
                        Fechar
                    </Button>
                </div>
            </div>
        ) : (
        // Caso contrário, mostra o formulário de pagamento normal
        <div style={{ animation: 'fadeIn 0.5s' }}> 
          <style type="text/css">
            {`
              @keyframes fadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
              }
            `}
          </style>
        <hr />
      {paymentApiMessage && (
          <Alert variant={paymentApiMessage.type} onClose={() => setPaymentApiMessage(null)} dismissible>
            {paymentApiMessage.text}
          </Alert>
        )}
        <h5>Paciente: {appointment.paciente?.nome || 'N/A'}</h5>
        <p>Data: {
          (() => {
            const [year, month, day] = appointment.data_agendamento.split('-');
            // Formata para DD/MM/YYYY para exibição, evitando conversões de fuso horário
            return `${day}/${month}/${year}`;
          })()
        } às {appointment.hora_marcada.slice(0,5)}</p> 
        {/* Seção de Contrato */}
        <Card className="mb-3 border-primary bg-primary bg-opacity-10">
            <Card.Body className="d-flex justify-content-between align-items-center">
                <div>
                    <FontAwesomeIcon icon={faFileContract} className="me-2 text-primary" />
                    <strong>Contrato de Prestação de Serviços</strong>
                    <p className="small mb-0 text-muted">Gere o contrato detalhado para o paciente assinar.</p>
                </div>
                {isContractSigned ? (
                    <Badge bg="success"><FontAwesomeIcon icon={faCheckCircle} /> Assinado</Badge>
                ) : (
                    <Button variant="primary" size="sm" onClick={handleGenerateContract} disabled={isFetchingPatientData}>
                        {isFetchingPatientData ? (
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />
                        ) : (
                            <FontAwesomeIcon icon={faTabletAlt} className="me-1" />
                        )}
                        {isFetchingPatientData ? ' Validando...' : ' Gerar no Tablet'}
                    </Button>
                )}
            </Card.Body>
        </Card>

        {/* Seção de Anamnese */}
        <Card className="mb-3 border-info bg-info bg-opacity-10">
            <Card.Body className="d-flex justify-content-between align-items-center">
                <div>
                    <FontAwesomeIcon icon={faClipboardList} className="me-2 text-info" />
                    <strong>Ficha de Anamnese</strong>
                    <p className="small mb-0 text-muted">Solicite ao paciente o preenchimento da ficha no tablet/celular.</p>
                </div>
                {isAnamneseComplete ? (
                    <Badge bg="success"><FontAwesomeIcon icon={faCheckCircle} /> Preenchida</Badge>
                ) : (
                    <Button variant="info" size="sm" onClick={handleGenerateAnamneseCode} disabled={isGeneratingAnamnese}>
                        {isGeneratingAnamnese ? <Spinner size="sm" className="me-1" /> : <FontAwesomeIcon icon={faTabletAlt} className="me-1" />}
                        {isGeneratingAnamnese ? ' Gerando...' : ' Gerar no Tablet'}
                    </Button>
                )}
            </Card.Body>
        </Card>
               
        <h6>Serviços a Pagar:</h6>
        <Form.Group className="mb-3" style={{ maxHeight: '150px', overflowY: 'auto', border: '1px solid #dee2e6', padding: '10px', borderRadius: '5px' }}>
          {sortedServices.map(service => {
            // Encontra o serviço correspondente no agendamento para obter o pivot
            const appointmentService = appointmentServices.find(s => s.id === service.id);

            // Verifica se o serviço é original do agendamento
            const isOriginalService = appointmentService?.origin === 'agendamento';
            const isSelected = appointmentServices.some(s => s.id === service.id);
            const isPacote = appointmentService?.isPacote;
            
            // NOVO: Verifica se o serviço é comissionável (veio da consulta)
            // A verificação agora é feita pela propriedade 'origin' que vem da API.
            // A comissão padrão (de venda) só é aplicável para serviços adicionados na consulta.
            const isCommissionable = appointmentService?.origin === 'consulta';
            
            const isPaid = paidServiceIds.has(service.id);
            return (
              <div key={service.id} className="d-flex justify-content-between align-items-center mb-2">
                <Form.Check 
                  type="checkbox"
                  id={`payment-service-${service.id}`}
                  label={(
                    () => {
                      const selectedService = appointmentServices.find(s => s.id === service.id);
                      const quantidade = selectedService?.quantidade || 1;
                      const valorPago = selectedService?.valor_pago || service.valor;
                      const valorUnitario = quantidade > 0 ? valorPago / quantidade : 0;

                      return (
                        <>
                          {service.nome}
                          {quantidade > 1 && <span className="text-muted small ms-2">{`(Qtd: ${quantidade}, Unit: R$ ${valorUnitario.toFixed(2)})`}</span>}
                          {isPacote && <Badge bg="info" className="ms-2">Pacote</Badge>}
                          {isOriginalService && <Badge bg="secondary" className="ms-2">Serviço original</Badge>}
                        </>
                      )}
                    )()
                  }                  
                  checked={isSelected}
                  onChange={() => handleServiceChange(service)}
                  className="flex-grow-1"
                  disabled={isPaid}
                />
                {/* NOVO: Campo de input para editar o valor do serviço */}
                {isSelected && !isPacote && (
                  <InputGroup size="sm" style={{ maxWidth: '150px' }}>
                    <InputGroup.Text>R$</InputGroup.Text>
                    <FormControl
                      type="number"
                      step="0.01"
                      value={appointmentServices.find(s => s.id === service.id)?.valor_pago || ''}
                      onChange={(e) => handleServiceValueChange(service.id, e.target.value)}
                      onFocus={(e) => e.target.select()}
                      onBlur={() => handleServiceValueBlur(service.id)} // NOVO: Validação no onBlur
                      disabled={isPaid}
                    />
                  </InputGroup>
                )}
                {isSelected && isPacote && (
                    <span className="ms-3 fw-bold text-muted">R$ 0,00</span>
                )}

                {/* A opção de comissão não aparece para serviços de pacote */}
                {isSelected && !isPacote && isCommissionable && service.percentual_comissao > 0 && hasCommissionableEmployees && (
                  <div className="d-flex align-items-center ms-3">
                    <Form.Check
                      type="checkbox"
                      id={`commission-check-${service.id}`}
                      label="Comissão"
                      checked={!!comissionedServices[service.id]?.enabled}
                      onChange={(e) => handleCommissionChange(service.id, e.target.checked)}
                      disabled={!hasCommissionableEmployees} // Desabilita se não houver funcionários comissionáveis
                      title={!hasCommissionableEmployees ? 'Nenhum funcionário está habilitado para receber comissão.' : 'Marcar para comissionar este serviço'}
                      className="me-2 text-nowrap"
                    />
                    {comissionedServices[service.id]?.enabled && (
                      <Form.Select
                        size="sm"
                        value={comissionedServices[service.id]?.funcionario_id || ''}
                        onChange={(e) => handleCommissionEmployeeChange(service.id, e.target.value)}
                        style={{ maxWidth: '150px' }}
                      >
                        <option value="">Selecione...</option>
                        {allFuncionarios
                            .filter(f => f.comissionavel) // Filtra para mostrar apenas funcionários comissionáveis
                            .map(f => <option key={f.id} value={f.id}>{f.nome}</option>)
                        }

                      </Form.Select>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </Form.Group>

        {/* --- INÍCIO DA NOVA SEÇÃO DE COMISSÃO ORIGINÁRIA --- */}
        {/* Só mostra esta seção se todos os serviços originais estiverem selecionados e se houver funcionários elegíveis */}
        {areAllInitialServicesSelected && employeesForOriginCommission.length > 0 && (
          <Card className="mt-3 bg-light border-success">
            <Card.Header as="h6" className="text-success-emphasis">
              <i className="bi bi-award-fill me-2"></i>
              Comissão Originária (Indicação)
            </Card.Header>
            <Card.Body className="py-2">
              <Row className="align-items-center">
                <Col xs={12} md={5}>
                  <Form.Check
                    type="switch"
                    id="origin-commission-check"
                    label="Bonificar pela indicação"
                    checked={originCommission.enabled}
                    onChange={(e) => handleOriginCommissionChange(e.target.checked)}
                  />
                </Col>
                <Col xs={12} md={7}>
                  {originCommission.enabled && (
                    <Form.Select size="sm" value={originCommission.funcionario_id} onChange={(e) => handleOriginCommissionEmployeeChange(e.target.value)}>
                      <option value="">Selecione o funcionário...</option>
                      {employeesForOriginCommission.map(f => <option key={f.id} value={f.id}>{f.nome}</option>)}
                    </Form.Select>
                  )}
                </Col>
              </Row>
            </Card.Body>
          </Card>
        )}

        <ListGroup.Item className="d-flex justify-content-between align-items-center fw-bold mb-3">
          Subtotal dos Serviços:
          <span>R$ {paymentSubtotal.toFixed(2)}</span>
        </ListGroup.Item>

        {/* NOVO: Exibe o desconto já concedido */}
          {totalDescontoJaConcedido > 0 && (
            <ListGroup.Item className="d-flex justify-content-between align-items-center text-danger mb-3">
                Desconto Concedido:
                <span>
                    - R$ {totalDescontoJaConcedido.toFixed(2)}
                </span>
            </ListGroup.Item>
        )}
        {/* NOVO: Exibe os valores já pagos de forma detalhada */}
        {totalServicosJaPagos > 0 && (
            <ListGroup.Item className="d-flex justify-content-between align-items-center text-primary mb-3">
                Valor Pago (Serviços):
                <span>
                    - R$ {((totalServicosJaPagos) - (totalDescontoJaConcedido)).toFixed(2)}
                </span>
            </ListGroup.Item>
        )}
        {totalAdicionaisJaPagos > 0 && (
          <ListGroup.Item className="d-flex justify-content-between align-items-center text-success mb-3">
              Valor Pago (Adicionais):
              <small>R$ {totalAdicionaisJaPagos.toFixed(2)}</small>
          </ListGroup.Item>
        )}
        

        {/* Card de Resumo da Cobertura do Convênio (Fase 2) */}
        {isLoadingCoverage ? (
          <div className="text-center my-3"><Spinner animation="border" size="sm" /> Verificando cobertura...</div>
        ) : coverageDetails && (
          <Card bg="light" className="mb-3 border-info">
            <Card.Header as="h6" className="text-info-emphasis">Resumo do Convênio</Card.Header>
            <ListGroup variant="flush">
              <ListGroup.Item className="d-flex justify-content-between bg-transparent">
                <span>Valor Total dos Serviços</span>
                <strong>R$ {paymentSubtotal.toFixed(2)}</strong>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex justify-content-between text-success bg-transparent">
                <span>Coberto pelo Convênio ({appointment.paciente.op_convenio})</span>
                <strong>- R$ {parseFloat(coverageDetails.valor_total_coberto_convenio).toFixed(2)}</strong>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex justify-content-between fw-bold bg-transparent">
                <span>Valor a Pagar (Paciente)</span>
                <strong>
                  R$ {(paymentSubtotal - parseFloat(coverageDetails.valor_total_coberto_convenio || 0)).toFixed(2)}
                </strong>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        )}

        <h6>Valores Adicionais:</h6>
        <Row className="mb-3">
          <Col md={8}>
            <Form.Group controlId="additionalValueDescription">
              <Form.Label>Descrição</Form.Label>
              <FormControl
                type="text"
                placeholder="Ex: Material extra, taxa de urgência"
                value={additionalValueDescription}
                onChange={(e) => setAdditionalValueDescription(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group controlId="additionalValue">
              <Form.Label>Valor (R$)</Form.Label>
              <InputGroup>
                <FormControl
                  type="number"
                  step="0.01"
                  value={additionalValue}
                  min="0" // Impede valores negativos diretamente no input
                  onFocus={(e) => e.target.select()} // Seleciona todo o texto ao focar
                  onChange={(e) => {
                    const val = Math.max(0, parseFloat(String(e.target.value).replace(/^0+(?=\d)/, '')) || 0); // Remove zero à esquerda e garante não negativo
                    setAdditionalValue(val);                  }}                />
              </InputGroup>
            </Form.Group>
          </Col>
        </Row>
        <hr />
        {/* --- NOVA SEÇÃO DE CUPOM --- */}
        <Row className="mb-3">
            <Col md={6}>
                <Form.Group controlId="couponSection">
                    <Form.Label>Cupom de Desconto</Form.Label>
                    <InputGroup>
                        <FormControl
                            placeholder="Ex: BEMVINDO10"
                            value={couponCode}
                            onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
                            disabled={!!appliedCoupon || isValidatingCoupon}
                        />
                        {appliedCoupon ? (
                            <Button variant="outline-danger" onClick={handleRemoveCoupon}>Remover</Button>
                        ) : (
                            <Button 
                                variant="outline-primary" 
                                onClick={handleApplyCoupon}
                                disabled={!couponCode || isValidatingCoupon}
                            >
                                {isValidatingCoupon ? <Spinner size="sm" /> : 'Aplicar'}
                            </Button>
                        )}
                    </InputGroup>
                </Form.Group>
            </Col>
        </Row>
        <hr />
        {/* Seção de Desconto Global */}
        <Row className="mb-3">
          {!appliedCoupon && (
            <Col md={4}>
                <Form.Group controlId="discountPercentage">
                    <Form.Label>Desconto (%):</Form.Label>
                    <FormControl
                        type="number"
                        step="0.01"
                        min="0"
                        max={MAX_DISCOUNT_PERCENTAGE}
                        value={isDiscountAuthorized ? discountPercentage : Math.min(discountPercentage, 5)}
                        onChange={handleDiscountChange}
                    />
                </Form.Group>
            </Col>
          )}
          <Col md={appliedCoupon ? 12 : 8} className="d-flex align-items-end justify-content-end">
                {appliedCoupon && (
                    <div className="text-end me-3 text-success">
                        <small className="d-block">Desconto Cupom:</small>
                        <strong>- R$ {parseFloat(appliedCoupon.valor_desconto).toFixed(2)}</strong>
                    </div>
                )}
                <h5 className="mb-0">Total a Pagar: R$ {totalDebt.toFixed(2)}</h5>
          </Col>

        </Row>

        <hr />

                    {/* --- SEÇÃO DE PAGAMENTOS MÚLTIPLOS --- */}
        <h6>Pagamentos:</h6>
        
        {/* Lista de Pagamentos Adicionados */}
        {payments.length > 0 && (
            <Table striped bordered hover size="sm" className="mb-3">
                <thead>
                    <tr>
                        <th>Forma</th>
                        <th className="text-end">Valor</th>
                        <th className="text-end">Taxa</th>
                        <th className="text-end">Total</th>
                        <th className="text-center" style={{width: '50px'}}>Ação</th>
                    </tr>
                </thead>
                <tbody>
                    {payments.map((p) => (
                        <tr key={p.id}>
                            <td>
                                {p.forma_pagamento.charAt(0).toUpperCase() + p.forma_pagamento.slice(1)}
                                {p.taxa_maquininha > 0 && <small className="text-muted ms-1">({p.taxa_maquininha}%)</small>}
                            </td>
                            <td className="text-end">R$ {p.valor.toFixed(2)}</td>
                            <td className="text-end">R$ {p.valor_taxa.toFixed(2)}</td>
                            <td className="text-end fw-bold">R$ {p.total_pago.toFixed(2)}</td>
                            <td className="text-center">
                                <Button variant="link" className="text-danger p-0" onClick={() => handleRemovePayment(p.id)}>
                                    <FontAwesomeIcon icon={faTrash} />
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan="3" className="text-end fw-bold">Total Recebido:</td>
                        <td className="text-end fw-bold text-success">R$ {paymentTotal.toFixed(2)}</td>
                        <td></td>
                    </tr>
                </tfoot>
            </Table>
        )}

        {/* Formulário para Adicionar Pagamento */}
        <Card className="bg-light mb-3">
            <Card.Body className="p-3">
                <Row className="align-items-end">
                    <Col md={4}>
                        <Form.Group controlId="paymentMethod">
                            <Form.Label>Forma de Pagamento:</Form.Label>
                            <Form.Select value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}>
                                <option value="dinheiro">Dinheiro</option>
                                <option value="pix">PIX</option>
                                <option value="debito">Débito</option>
                                <option value="credito">Crédito</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col md={3}>
                        <Form.Group controlId="paymentAmount">
                            <Form.Label>Valor (R$):</Form.Label>
                            <FormControl
                                type="number"
                                step="0.01"
                                min="0"
                                value={currentPaymentAmount}
                                onChange={(e) => setCurrentPaymentAmount(e.target.value)}
                                placeholder="0.00"
                            />
                        </Form.Group>
                    </Col>
                    {(paymentMethod === 'credito' || paymentMethod === 'debito') && (
                        <Col md={3}>
                            <Form.Group controlId="cardFeePercentage">
                                <Form.Label>Taxa (%):</Form.Label>
                                <FormControl
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    value={cardFeePercentage}
                                    onChange={(e) => setCardFeePercentage(e.target.value)}
                                    placeholder="0"
                                />
                            </Form.Group>
                        </Col>
                    )}
                    <Col md={2}>
                        <Button variant="outline-primary" className="w-100" onClick={handleAddPayment}>
                            <FontAwesomeIcon icon={faPlus} /> Add
                        </Button>
                    </Col>
                </Row>
                {remainingAmount > 0 && (
                    <div className="mt-2 text-end text-muted small">
                        Falta adicinar a forma de pagamento: <strong>R$ {remainingAmount.toFixed(2)}</strong>
                    </div>
                )}
            </Card.Body>
        </Card>
        </div>
        )
        )}
      </Modal.Body>
      {/* Oculta o rodapé padrão se estiver na tela de sucesso (pois ela tem seus próprios botões) */}
      {!lastPaymentData && (
      <Modal.Footer>
      <Button variant="secondary" onClick={handleClose} disabled={isProcessingPayment}>Cancelar</Button>
        {!isLoadingData && (
          <Button variant="success" onClick={handleConfirm} disabled={isProcessingPayment || payments.length === 0}>
            {isProcessingPayment ? (
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2"/>
            ) : null}
            {isProcessingPayment ? 'Processando...' : 'Confirmar Pagamento'}
          </Button>
        )}
      </Modal.Footer>
      )}

      {/* --- NOVO MODAL DE AUTORIZAÇÃO DE DESCONTO --- */}
      <Modal show={showAuthModal} onHide={() => { setShowAuthModal(false); setDiscountPercentage(5); setAuthPassword(''); }} centered backdrop="static">
        <Modal.Header>
          <Modal.Title>Autorização Necessária</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Para aplicar um desconto acima de 5%, é necessária a senha de um Gerente.</p>
          {authError && <Alert variant="danger">{authError}</Alert>}
          <Form.Group controlId="authPassword">
            <Form.Label>Senha Gerencial:</Form.Label>
            <Form.Control
              type="password"
              value={authPassword}
              onChange={(e) => setAuthPassword(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleAuthorizeDiscount()}
              autoFocus
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => { setShowAuthModal(false); setDiscountPercentage(5); setAuthPassword(''); }} disabled={isAuthorizing}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleAuthorizeDiscount} disabled={isAuthorizing || !authPassword}>
            {isAuthorizing ? <Spinner as="span" size="sm" /> : 'Autorizar'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de Acompanhamento da Assinatura */}
      <ContratoAssinaturaModal 
        show={showContractModal}
        onHide={() => setShowContractModal(false)}
        codigo={contractCode}
        agendamentoId={appointment.id}
        onSigned={() => {
            setIsContractSigned(true);
            setShowContractModal(false);
        }}
      />

      {/* Modal de Complemento de Dados do Paciente */}
      <Modal show={showPatientDataModal} onHide={() => setShowPatientDataModal(false)} size="lg" centered backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Dados Obrigatórios para o Contrato</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="info">
            Os campos abaixo são necessários para a validade jurídica do contrato e ainda não estão preenchidos no perfil do paciente.
          </Alert>
          <Form>
            <Row>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Nome Completo *</Form.Label>
                  <Form.Control 
                    value={patientForm.nome} 
                    onChange={e => setPatientForm({...patientForm, nome: e.target.value})} 
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>CPF *</Form.Label>
                  <InputMask mask="999.999.999-99" value={patientForm.cpf} onChange={e => setPatientForm({...patientForm, cpf: e.target.value})}>
                    {(inputProps) => <Form.Control {...inputProps} type="text" />}
                  </InputMask>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Estado Civil *</Form.Label>
                  <Form.Select value={patientForm.estado_civil} onChange={e => setPatientForm({...patientForm, estado_civil: e.target.value})}>
                    <option value="Nao informado">Selecione...</option>
                    <option value="Solteiro">Solteiro(a)</option>
                    <option value="Casado">Casado(a)</option>
                    <option value="Divorciado">Divorciado(a)</option>
                    <option value="Viuvo">Viúvo(a)</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Profissão *</Form.Label>
                  <Form.Control 
                    value={patientForm.profissao} 
                    onChange={e => setPatientForm({...patientForm, profissao: e.target.value})} 
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>E-mail *</Form.Label>
                  <Form.Control 
                    type="email"
                    value={patientForm.email} 
                    onChange={e => setPatientForm({...patientForm, email: e.target.value})} 
                  />
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Endereço Completo *</Form.Label>
                  <Form.Control 
                    value={patientForm.endereco} 
                    placeholder="Rua, número, bairro, cidade - UF"
                    onChange={e => setPatientForm({...patientForm, endereco: e.target.value})} 
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>DDD *</Form.Label>
                  <Form.Control 
                    maxLength={2}
                    value={patientForm.dddcelular} 
                    onChange={e => setPatientForm({...patientForm, dddcelular: e.target.value})} 
                  />
                </Form.Group>
              </Col>
              <Col md={8}>
                <Form.Group className="mb-3">
                  <Form.Label>Celular *</Form.Label>
                  <Form.Control 
                    value={patientForm.celular} 
                    onChange={e => setPatientForm({...patientForm, celular: e.target.value})} 
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPatientDataModal(false)}>
            Cancelar
          </Button>
          <Button 
            variant="primary" 
            onClick={handleUpdatePatientAndGenerate} 
            disabled={isUpdatingPatient || isPatientFormInvalid}
          >
            {isUpdatingPatient ? <Spinner size="sm" /> : 'Salvar e Gerar Contrato'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal para exibir o código da Anamnese */}
      <Modal show={showAnamneseCodeModal} onHide={() => setShowAnamneseCodeModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Código de Acesso - Anamnese</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-4">
          <p className="mb-4">Peça ao paciente para escanear o QR Code ou digitar o código abaixo no tablet:</p>
          
          {/* Exibição do QR Code */}
          <div className="mb-4 p-3 bg-white d-inline-block border rounded shadow-sm">
            <QRCodeCanvas 
              value={`${window.location.origin}/anamnese/${anamneseCode}`}
              size={200}
              level={"H"}
              includeMargin={true}
            />
            <div className="mt-2 small text-muted">Acesso Instantâneo</div>
          </div>

          {/* Exibição do Código Alfanumérico */}
          <div className="display-5 fw-bold text-primary mb-3" style={{ letterSpacing: '5px' }}>
            {anamneseCode}
          </div>

          <Alert variant="warning" className="small">
            Este código expira em 1 hora e serve para identificação do paciente no dispositivo móvel.
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAnamneseCodeModal(false)}>Fechar</Button>
        </Modal.Footer>
      </Modal>
    </Modal>
  );
};

export default PaymentModal;